import "./style.scss";
import "./style-mob.scss";
import { FC, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface ISteps {
  stepOne: string;
  stepTwo: string;
  stepThree: string;
  stepFour: string;
  stepFive: string;
}

interface AdmissionProcessStepsProps {
  steps: ISteps;
}

const AdmissionProcessSteps: FC<AdmissionProcessStepsProps> = ({ steps }) => {
  const { ref, inView } = useInView({
    threshold: 0.7,
    triggerOnce: true,
  });

  const [isMobile, setIsMobile] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
    setHasMounted(true);
  }, []);

  const stepsArray = [
    { label: steps.stepOne, className: "one" },
    { label: steps.stepTwo, className: "two" },
    { label: steps.stepThree, className: "three" },
    { label: steps.stepFour, className: "four" },
    { label: steps.stepFive, className: "five" },
  ];

  const stepDelays = [0, 0.6, 1.2, 1.8, 2.4];

  if (!hasMounted) return null;

  return (
    <div className="admission-process-body" ref={ref}>
      <div className="admission-process-line-wrapper">
        <motion.div
          className="admission-process-line"
          initial={isMobile ? { clipPath: "inset(0 0 100% 0)" } : { clipPath: "inset(0 100% 0 0)" }}
          animate={
            inView
              ? isMobile
                ? { clipPath: "inset(0 0 0% 0)" }
                : { clipPath: "inset(0 0% 0 0)" }
              : {}
          }
          transition={{ duration: 2.8, ease: "easeInOut" }}
        />
      </div>

      {stepsArray.map((step, index) => (
        <motion.div
          className={`admission-process-step ${step.className}`}
          key={index}
          initial={{ opacity: 0, y: 0 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{
            duration: 0.5,
            delay: stepDelays[index],
          }}
        >
          <span className="admission-process-step-number">{`0${index + 1}`}</span>
          <span className="admission-process-step-description">{step.label}</span>
        </motion.div>
      ))}
    </div>
  );
};

export default AdmissionProcessSteps;
